import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { FeedUsageTable } from '@app/components/apps/FeedMaterialUsage/FeedMaterialUsageTable';

const AllFeedUsage: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: `/feed-material-usage`, breadcrumbName: `Feed Raw Material Usage` }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Usage',
      <BaseButton type="primary" size="small" onClick={() => navigate('/add-feed-usage')}>
        Add Usage
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Feed Material Usage</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FeedUsageTable />
        </Col>
      </Row>
    </>
  );
};

export default AllFeedUsage;
